"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable @typescript-eslint/no-explicit-any , @typescript-eslint/explicit-module-boundary-types */


var ApiServiceSingleton = /*#__PURE__*/(0, _createClass2.default)(function ApiServiceSingleton() {
  (0, _classCallCheck2.default)(this, ApiServiceSingleton);
});
(0, _defineProperty2.default)(ApiServiceSingleton, "cookies", {});
(0, _defineProperty2.default)(ApiServiceSingleton, "Logger", '');
(0, _defineProperty2.default)(ApiServiceSingleton, "storeAppInfo", function (appInfo) {
  var _appInfo$abc;

  ApiServiceSingleton.cookies = _objectSpread(_objectSpread({}, ApiServiceSingleton.cookies), appInfo);
  ApiServiceSingleton.Logger = appInfo === null || appInfo === void 0 ? void 0 : (_appInfo$abc = appInfo.abc) === null || _appInfo$abc === void 0 ? void 0 : _appInfo$abc.split('|')[1];
});
(0, _defineProperty2.default)(ApiServiceSingleton, "getAppInfo", function () {
  return ApiServiceSingleton.cookies;
});
(0, _defineProperty2.default)(ApiServiceSingleton, "getLogger", function () {
  return ApiServiceSingleton.Logger;
});
var _default = ApiServiceSingleton;
exports.default = _default;